import { render, staticRenderFns } from "./RptSlipJournalItem.vue?vue&type=template&id=fad65236&"
import script from "./RptSlipJournalItem.vue?vue&type=script&lang=ts&"
export * from "./RptSlipJournalItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports